import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { FanspeedActionsUnion, FanspeedActionTypes, FanspeedLocationModel } from './fanspeed.actions';

export const inRoomFanspeedFeatureKey = 'inroom-fanspeed';

export type FanspeedState = EntityState<FanspeedLocationModel>;

export function selectFanspeedIdFromFanspeed(fanspeed: FanspeedLocationModel) {
  return selectFanspeedId(fanspeed.HotelCode ?? '', fanspeed.Room ?? '');
}

export function selectFanspeedId(hotelCode: string, room: string) {
  return hotelCode + '-' + room;
}

export const adapter: EntityAdapter<FanspeedLocationModel> = createEntityAdapter<FanspeedLocationModel>({
  selectId: selectFanspeedIdFromFanspeed,
});

export const initialState: FanspeedState = adapter.getInitialState();

export function fanspeedReducer(state: FanspeedState = initialState, action: FanspeedActionsUnion) {
  switch (action.type) {
    case FanspeedActionTypes.LOAD_FANSPEED:
      return adapter.addOne(action.payload, state);
    case FanspeedActionTypes.UPDATE_FANSPEED:
      return adapter.updateOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectFanspeedIds = selectIds;

export const selectFanspeedEntities = selectEntities;

export const selectAllFanspeeds = selectAll;

export const selectFanspeedTotal = selectTotal;
